export const SidebarSignupOverlay = {
  extends: 'SidebarPricingOverlay',
  SimpleOverlay: {
    background: 'electricBlue'
  },
  Notification: {
    onClick: (f, el, st) => {
      el.call('openRouterModal', '/settings', {
        key: '/signup'
      })
    },
    Hgroup: {
      H: {
        text: '{{ editor.overlay.unlockEditing | polyglot }}'
      },
      P: {
        text: '{{ editor.overlay.unlockEditingDescr | polyglot }}'
      }
    }
  }
}
